module.exports = __webpack_public_path__ + "static/golem.649a30fb.svg";